import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerDevicesPage from "../pages/DsokCustomerDevicesPage";

export const dsokCustomerDevicesRoute = {
  path: "/dsok/customer-detail/:customerUrl/devices",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerDevicesPage} />
    </DsokCustomerDetailProvider>
  ),
};
